module.exports = [{"source":"/new-caulking","destination":"/","permanent":true},{"source":"/contactus","destination":"/","permanent":true}];